import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn
} from '@angular/router';
import { IntershiftMessageService } from '../services/intershiftMessage.service';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../services/toast/toast.service';

@Injectable({ providedIn: 'root' })
class PermissionsService {
  toastService = inject(ToastService);

  constructor(
    private intershiftMessageService: IntershiftMessageService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    let mustRead = await firstValueFrom(this.intershiftMessageService.getMustReadNotesMessages());
    if (mustRead) {
      this.toastService.showInfo("", "You must first read your unread messages before you can access work plans or residents.");
      return false;
    }
    return true;
  }
}
export const MustReadMessageGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  return inject(PermissionsService).canActivate(next, state);
};
